import { requiredParam } from '../utilities/global-utils';
import recorders from './recorders';

const _trackAnalytics = (schema) => {
  try {
    if (schema) {
      if (Array.isArray(schema)) {
        window.dataLayer.push(...schema);
      } else {
        window.dataLayer.push(schema);
      }
      console.warn('GTM Tracking: ', { ...schema }); // eslint-disable-line no-console
    }
  } catch (e) {
    console.warn('GTM Tracking wasn`t initiated properly, tried to track: ', schema); // eslint-disable-line no-console
  }
};


export const ANALYTICS_ACTION = 'ANALYTICS_TRACK';
// Fake action creator to send analytics
export const sendAnalytics = payload => ({
  type: ANALYTICS_ACTION,
  // payload object must contain at least eventCreator
  payload,
});


export const performTrack = ({
  // eventCreator is either a function receiveing the current store
  // and returns an event objet or an event object previously made.
  // ** TODA LA LÓGICA DE NEGOCIO VA DENTRO DEL EVENTCREATOR **
  eventCreator = requiredParam('eventCreator'),
  // options is used to execute another recorders providing the
  // action structure needed for them
  options,
  // current store state
  state,
} = {}) => {
  const trackers = recorders.slice(1); // omit GTM recorder
  // get event either from the creator or the passed param
  const event = (typeof eventCreator === 'function') ? eventCreator(state) : eventCreator;

  _trackAnalytics(event);

  if (!options) {
    return;
  }

  // we're stepping into other recorders
  trackers.forEach(t => {
    if (typeof t !== 'function') {
      return;
    }
    t({ state, ...options });
  });
};
